import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { RolesService } from 'src/app/services/roles-service/roles.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';


@Component({
  selector: 'app-roles-new-role-dashboard',
  templateUrl: './roles-new-role-dashboard.component.html',
  styleUrls: ['./roles-new-role-dashboard.component.scss']
})
export class RolesNewRoleDashboardComponent implements OnInit, OnDestroy {

  menuSections;
  roles;
  getRoleListSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private userStorageService: UserStorageService,
              private rolesService: RolesService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSections();
    this.getRolesList();
  }

  private getSections() {
    this.menuSections = this.userStorageService.getMenuSectionList();
  }

  private getRolesList() {
    this.getRoleListSubscription = this.rolesService.getRolesList().subscribe(
      (res) => {
        this.roles = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-magic', 'roles-page.new role', '/account/roles', [new BRoute('account-page.account', '/account'), new BRoute('roles-page.roles', '/account/roles'), new BRoute('roles-page.new role')]));
  }

  ngOnDestroy() {
    if (this.getRoleListSubscription) { this.getRoleListSubscription.unsubscribe(); }
  }
}
